import { View } from 'foundations-components/components/View';
import styled from 'foundations-theming/utils';
import { PageTitle, PageSubTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { breakpointValues } from 'pricing-pages-ui-components/constants/Breakpoints';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const MOBILE_EM = (breakpointValues.tablet - 1) / 16;
const HeaderRoot = styled(View)(({
  theme
}) => ({
  [`@media (max-width: ${MOBILE_EM}em)`]: {
    paddingInline: theme.space[300]
  }
}));
export const PublicPageHeader = ({
  icon,
  title,
  subtitles,
  children
}) => {
  return /*#__PURE__*/_jsxs(HeaderRoot, {
    textAlign: "center",
    marginBlockEnd: "800",
    children: [/*#__PURE__*/_jsxs(PageTitle, {
      "aria-level": 1,
      children: [icon, title]
    }), subtitles === null || subtitles === void 0 ? void 0 : subtitles.map((subtitle, index) => /*#__PURE__*/_jsx(PageSubTitle, {
      children: subtitle
    }, index)), children]
  });
};